export function getRiskRating(consequence, likelihood) {
  const likelihoodLevels = ['Rare', 'Unlikely', 'Possible', 'Likely', 'Almost Certain'];
  const consequenceLevels = ['Low', 'Minor', 'Moderate', 'Major', 'Catastrophic'];

  const riskMatrix = [
    ["#009A51", "#009A51", "#8EC045", "#8EC045", "#FEBC05"], // Rare
    ["#009A51", "#8EC045", "#8EC045", "#FEBC05", "#FEBC05"], // Unlikely
    ["#009A51", "#8EC045", "#8EC045", "#FEBC05", "#D13016"], // Possible
    ["#8EC045", "#8EC045", "#FEBC05", "#FEBC05", "#D13016"], // Likely
    ["#8EC045", "#8EC045", "#FEBC05", "#D13016", "#D13016"], // Almost Certain
  ];

  const ratingText = {
    "#009A51": "Low",
    "#8EC045": "Medium",
    "#FEBC05": "High",
    "#D13016": "Extreme"
  };

  // 🧹 Clean and normalize inputs
  const clean = (v) => v ? v.toString().trim().toLowerCase() : '';

  const likelihoodIndex = likelihoodLevels.findIndex(
    l => l.toLowerCase() === clean(likelihood)
  );
  const consequenceIndex = consequenceLevels.findIndex(
    c => c.toLowerCase() === clean(consequence)
  );

  if (likelihoodIndex === -1 || consequenceIndex === -1) {
    return { rating: 'N/A', color: 'dark' };
  }

  const color = riskMatrix[likelihoodIndex][consequenceIndex];
  const rating = ratingText[color] || 'N/A';

  return { rating, color };
}
